import { useApplicantAPI } from "@certn/api";
import {
  Card,
  Container,
  Divider,
  Layout,
  Loader,
  SecondaryTopNav,
  SectionMessage,
} from "@certn/cascadia-react";
import { Report } from "@certn/report";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

import { ReportAccessDenied } from "./ReportAccessDenied";

import { ReportHeader } from "./ReportHeader";
import constants from "../../../constants";
import { useDocumentTitle } from "../../hooks/api/useDocumentTitle";

export function ReportPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { caseId } = useParams();

  const { data: caseData, isLoading: caseLoading } = useApplicantAPI(
    `/api/internal/applicant/case/${caseId}/` as "/api/internal/applicant/case/{id}/"
  );

  const { data, isLoading } = useApplicantAPI(
    `/api/internal/applicant/case/${caseId}/report/` as "/api/internal/applicant/case/{id}/report/"
  );

  useDocumentTitle(
    caseData?.restrict_applicant_communications
      ? t("Report Access Restricted — Certn")
      : t("Report — Certn")
  );

  if (caseLoading || isLoading) {
    return (
      <div
        className={css({
          display: "flex",
          height: "100vh",
          alignItems: "center",
          justifyContent: "center",
        })}
      >
        <Loader />
      </div>
    );
  }

  if (caseData?.restrict_applicant_communications) {
    return <ReportAccessDenied />;
  }

  if (!data) {
    return (
      <Card border="border-base">
        <SectionMessage
          sectionTitle={t("Page not found!")}
          type="info"
          icon="warning"
        />
      </Card>
    );
  }

  return (
    <Layout
      layout="wide"
      backgroundColor="surface-sunken"
      header={
        <>
          <SecondaryTopNav
            leftIcon="close"
            onleftIconOnPress={() => navigate("/")}
            testID="case-details-secondary-top-nav"
            titleArea={{
              subtitle: t("Case ID") + ": " + caseId,
              title: t("Report details"),
            }}
          />
          <Divider />
          <ReportHeader />
        </>
      }
    >
      <Container>
        <Report
          clickwrapAccessID={constants.VITE_CLICKWRAP_ACCESS_ID}
          watermark={constants.VITE_USE_WATERMARKS_ON_REPORTS}
          reportData={data?.report_data as any}
          appIdentifier="APPLICANT_PORTAL"
        />
      </Container>
    </Layout>
  );
}
